import { destinationSchema } from 'store/schemas/database.schema';
import { actionCreators } from '../actions/metaDatabase.destinations.actions';
import DestinationsRepository from '../../services/repositories/DestinationsRepository';
import { buildMetaDestinationSelector, buildMetaDestinationsSelector } from '../selectors/destinations.selector';
import { loadDestinationEntityBySlug, loadAll  } from './helpers';

export function loadDestinationBySlug(slug, includes = null, repository = null)
{
    let finalRepository = repository;

    if (!finalRepository) finalRepository = new DestinationsRepository();

    return loadDestinationEntityBySlug(slug, includes, buildMetaDestinationSelector, actionCreators, finalRepository, destinationSchema);
}

export function loadAllDestinations(repository = null)
{
    let finalRepository = repository;

    if (!finalRepository) finalRepository = new DestinationsRepository();

    return loadAll(buildMetaDestinationsSelector, actionCreators, finalRepository, destinationSchema);
}
